import { useState } from "react";
import styled, { css } from "styled-components";

const ResultItem = styled.div<{ importantStyles?: {}}>`
    // margin-bottom: 14px;
    cursor: pointer;
    transition: 0.15s;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 7px;
    padding-bottom: 7px;

    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
    &:hover {
        //opacity: 0.7;
        background: #262C30;
        ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
    }
`

const ResultItemName = styled.div<{ importantStyles?: {}}>`
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
`


const ResultItemType = styled.div<{ importantStyles?: {}}>`
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: #FEFEFE;
    opacity: 0.47;
    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
`



export default function ResItem(props: any) {
    const { name, description, coordinates, groupId, isNoResult, onClickRes, styles } = props;

    if (isNoResult) {
        return <ResultItem>
                    <ResultItemName>
                        Нет результатов
                    </ResultItemName>
                </ResultItem> 
    }

    return <>
            <ResultItem className={'point-item'} importantStyles={styles} onClick={() => onClickRes(coordinates, name, description, groupId)}>
                <ResultItemName importantStyles={styles}>
                    {name}
                </ResultItemName>
                <ResultItemType importantStyles={styles}>
                    {coordinates.split(" ").reverse().join(" ")}
                </ResultItemType>
            </ResultItem>
        </>
}import { useState } from "react";
import styled, { css } from "styled-components";

const ResultItem = styled.div<{ importantStyles?: {}}>`
    // margin-bottom: 14px;
    cursor: pointer;
    transition: 0.15s;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 7px;
    padding-bottom: 7px;

    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
    &:hover {
        //opacity: 0.7;
        background: #262C30;
        ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
    }
`

const ResultItemName = styled.div<{ importantStyles?: {}}>`
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
`


const ResultItemType = styled.div<{ importantStyles?: {}}>`
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: #FEFEFE;
    opacity: 0.47;
    ${({ importantStyles }) => importantStyles && css`${importantStyles}`}
`



export default function ResItem(props: any) {
    const { name, description, coordinates, groupId, isNoResult, onClickRes, styles } = props;

    if (isNoResult) {
        return <ResultItem>
                    <ResultItemName>
                        Нет результатов
                    </ResultItemName>
                </ResultItem> 
    }

    return <>
            <ResultItem className={'point-item'} importantStyles={styles} onClick={() => onClickRes(coordinates, name, description, groupId)}>
                <ResultItemName importantStyles={styles}>
                    {name}
                </ResultItemName>
                <ResultItemType importantStyles={styles}>
                    {coordinates.split(" ").reverse().join(" ")}
                </ResultItemType>
            </ResultItem>
        </>
}